import { render, staticRenderFns } from "./ServiceLightStep5.vue?vue&type=template&id=6d788884"
import script from "./ServiceLightStep5.vue?vue&type=script&scoped=true&lang=js"
export * from "./ServiceLightStep5.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./ServiceLightStep5.vue?vue&type=style&index=0&id=6d788884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports